var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingPatientsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/profile-2user"
  }, /*#__PURE__*/React.createElement("g", {
    id: "profile-2user"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.63216 9.05768C7.54883 9.04935 7.44883 9.04935 7.35716 9.05768C5.37383 8.99102 3.79883 7.36602 3.79883 5.36602C3.79883 3.32435 5.44883 1.66602 7.49883 1.66602C9.5405 1.66602 11.1988 3.32435 11.1988 5.36602C11.1905 7.36602 9.6155 8.99102 7.63216 9.05768Z",
    fill: "white",
    stroke: "#566875",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.6747 3.33398C15.2914 3.33398 16.5914 4.64232 16.5914 6.25065C16.5914 7.82565 15.3414 9.10899 13.7831 9.16732C13.7164 9.15899 13.6414 9.15899 13.5664 9.16732",
    stroke: "#566875",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.46563 12.134C1.44896 13.484 1.44896 15.684 3.46563 17.0257C5.75729 18.559 9.51563 18.559 11.8073 17.0257C13.824 15.6757 13.824 13.4757 11.8073 12.134C9.52396 10.609 5.76563 10.609 3.46563 12.134Z",
    stroke: "#566875",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M15.2832 16.666C15.8832 16.541 16.4499 16.2993 16.9165 15.941C18.2165 14.966 18.2165 13.3577 16.9165 12.3827C16.4582 12.0327 15.8999 11.7993 15.3082 11.666",
    stroke: "#566875",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingPatientsIcon);
export default __webpack_public_path__ + "static/media/setting-patients-icon.551259e811d8c60048769c658d5fc33b.svg";
export { ForwardRef as ReactComponent };